const size = {
  mobile: "480px",
  tablet: "768px",
  smallDesktop: "1024px",
};

export const device = {
  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  smallDesktop: `(max-width: ${size.smallDesktop})`,
};



// WEBPACK FOOTER //
// ./src/core/admin/components/styled/media-queries.js